// config/routeConfig.ts

import { useRouter } from "next/router";
import { PagesEnum, RouteTypesEnum } from "./enums";

const routeConfig = {
  "/": RouteTypesEnum.ALL_USERS,
  "/cookie-check": RouteTypesEnum.ALL_USERS,
  ["/" + PagesEnum.Home]: RouteTypesEnum.ALL_USERS,
  ["/" + PagesEnum.PartnerAccount]: RouteTypesEnum.ALL_USERS,
  ["/" + PagesEnum.Cart]: RouteTypesEnum.ALL_USERS,
  ["/" + PagesEnum.Tip]: RouteTypesEnum.ALL_USERS,
  ["/" + PagesEnum.NotFound]: RouteTypesEnum.ALL_USERS,
  ["/" + PagesEnum.Item]: RouteTypesEnum.ALL_USERS,
  ["/" + PagesEnum.EditItem]: RouteTypesEnum.ALL_USERS,
  ["/" + PagesEnum.Location]: RouteTypesEnum.ALL_USERS,
  ["/" + PagesEnum.LoyaltyTermsAndConditions]: RouteTypesEnum.ALL_USERS,
  ["/" + PagesEnum.OurPolicies]: RouteTypesEnum.ALL_USERS,
  ["/" + PagesEnum.Login]: RouteTypesEnum.VISTORS_ONLY,
  ["/" + PagesEnum.Verify]: RouteTypesEnum.VISTORS_ONLY,
  ["/" + PagesEnum.Pay]: RouteTypesEnum.CUSTOMERS_ONLY,
  ["/" + PagesEnum.PaymentFailed]: RouteTypesEnum.CUSTOMERS_ONLY,
  ["/" + PagesEnum.AppleWallet]: RouteTypesEnum.ALL_USERS,
  ["/" + PagesEnum.AppleWalletLogin]: RouteTypesEnum.VISTORS_ONLY,
  ["/" + PagesEnum.AppleWalletVerify]: RouteTypesEnum.VISTORS_ONLY,
  ["/" + PagesEnum.AppleWalletConfirmation]: RouteTypesEnum.ALL_USERS,
};

export const getRouteType = (): RouteTypesEnum => {
  const router = useRouter();

  return routeConfig[router.pathname] || RouteTypesEnum.ALL_USERS; // Default to PUBLIC if not specified
};
